import { useHistory } from "react-router";
import { useEffect, useMemo } from 'react'
import { useUser } from "../../../providers/UserContext";

import {
  Container,
  SizeContainer,
  LogoImg,
  ContainerGame,
  ButtonGame,
  ImgButtonGame,
  BackButton,
} from "./style";

const Home = () => {
  const history = useHistory();

  const { Logout, DoAForcedGet, industry, isNeededSetupIndustry } = useUser()

  useEffect(() => {
    DoAForcedGet()
  }, [industry])

  return (
    <Container>
      <SizeContainer>
        <LogoImg src="./images/logohAsset 3.png" />
        {industry?.industria ?
          <ContainerGame>
            <ButtonGame onClick={() => history.push(isNeededSetupIndustry ? "/selectionFactory" : "/mapMenu")}>
              <ImgButtonGame src="./images/dado1.svg" />
              Jogar
            </ButtonGame>
            <ButtonGame onClick={() => history.push("/weeklyReportPcp")}>
              <ImgButtonGame src="./images/dado4.svg" />
              Histórico de Jogadas
            </ButtonGame>
          </ContainerGame>
          :
          <ButtonGame style={{ padding: 20 }}>
            Aguarde uma industria cadastrá-lo para poder jogar
          </ButtonGame>
        }
        <BackButton onClick={() => {
          Logout();
          history.push("/");
        }
        } />
      </SizeContainer>
    </Container>
  );
};
export default Home;
